import * as setup from '@/setup';
import * as audio from '@/utils/audio';
import Header from '@/objects/header';
import { HEADER_HEIGHT } from '@/constants';

export default class HowtoPlay extends Phaser.Scene {
	constructor() {
		super({key: 'HowtoPlay'});
		this.scrollContainer = null;
		this.scrollY = 0;
		this.maxScrollY = 0;
	}

	create() {
		console.log('create Howto Play');

		const width = this.sys.game.config.width;
		const height = this.sys.game.config.height;
		const centerX = width / 2;
		const bottomPadding = 20;

		// Background
		this.add
			.image(centerX, height / 2, 'background')
			.setOrigin(0.5, 0.5);

		// Header
		this.createHeader(centerX);

		// Area scrollabile: da sotto l'header fino a 20px dal fondo
		const scrollAreaTop = HEADER_HEIGHT;
		const scrollAreaHeight = height - HEADER_HEIGHT - bottomPadding;

		// Container per contenuto scrollabile
		this.scrollContainer = this.add.container(0, scrollAreaTop);
		let currentY = 30;

		// Spiegazione ditloide
		let ditloideText = this.add.text(
			centerX,
			currentY,
			'Tanaca è un gioco in cui devi indovinare\nTITOLO e AUTORE di un \nLIBRO, FILM o una CANZONE\navendo le iniziali delle parole.\n\nLe lettere con il punto (.)\n sono quelle da indovinare.',
			{
				fontSize: 36,
				fontFamily: 'Arial',
				fill: '#FFFFFF',
				align: 'center'
			}
		).setOrigin(0.5, 0);
		this.scrollContainer.add(ditloideText);
		currentY += ditloideText.height + 30;

		// Esempio Libro
		let exampleBookTitle = this.add.text(
			40,
			currentY,
			'ESEMPIO - LIBRO:',
			{
				fontSize: 32,
				fontFamily: 'Luckiest Guy',
				fill: '#eccc36',
				align: 'left'
			}
		).setOrigin(0, 0.5);
		this.scrollContainer.add(exampleBookTitle);

		let exampleBookDitloide = this.add.text(
			290,
			currentY + 2,
			'UNO N. E C. DI L.P.',
			{
				fontSize: 38,
				fontFamily: 'Arial',
				fill: '#FFFFFF',
				align: 'left'
			}
		).setOrigin(0, 0.5);
		this.scrollContainer.add(exampleBookDitloide);
		currentY += 50;

		let exampleBookSolution = this.add.text(
			40,
			currentY,
			'Uno Nessuno e Centomila di Luigi Pirandello',
			{
				fontSize: 32,
				fontFamily: 'Arial',
				fill: '#a5bd3a',
				align: 'left'
			}
		).setOrigin(0, 0.5);
		this.scrollContainer.add(exampleBookSolution);
		currentY += 70;

		// Esempio Film
		let exampleFilmTitle = this.add.text(
			40,
			currentY + 5,
			'ESEMPIO - FILM:',
			{
				fontSize: 32,
				fontFamily: 'Luckiest Guy',
				fill: '#eccc36',
				align: 'left'
			}
		).setOrigin(0, 0.5);
		this.scrollContainer.add(exampleFilmTitle);

		let exampleFilmDitloide = this.add.text(
			270,
			currentY + 5,
			'IL S. DEGLI A. DI P. J.',
			{
				fontSize: 38,
				fontFamily: 'Arial',
				fill: '#FFFFFF',
				align: 'left'
			}
		).setOrigin(0, 0.5);
		this.scrollContainer.add(exampleFilmDitloide);
		currentY += 50;

		let exampleFilmSolution = this.add.text(
			40,
			currentY,
			'Il Signore degli Anelli di Peter Jackson',
			{
				fontSize: 32,
				fontFamily: 'Arial',
				fill: '#a5bd3a',
				align: 'left'
			}
		).setOrigin(0, 0.5);
		this.scrollContainer.add(exampleFilmSolution);
		currentY += 70;

		// Esempio Canzone
		let exampleSongTitle = this.add.text(
			40,
			currentY,
			'ESEMPIO - CANZONE:',
			{
				fontSize: 32,
				fontFamily: 'Luckiest Guy',
				fill: '#eccc36',
				align: 'left'
			}
		).setOrigin(0, 0.5);
		this.scrollContainer.add(exampleSongTitle);

		let exampleSongDitloide = this.add.text(
			335,
			currentY,
			'B. R. DI Q.',
			{
				fontSize: 38,
				fontFamily: 'Arial',
				fill: '#FFFFFF',
				align: 'left'
			}
		).setOrigin(0, 0.5);
		this.scrollContainer.add(exampleSongDitloide);
		currentY += 50;

		let exampleSongSolution = this.add.text(
			40,
			currentY,
			'Bohemian Rhapsody di Queen',
			{
				fontSize: 32,
				fontFamily: 'Arial',
				fill: '#a5bd3a',
				align: 'left'
			}
		).setOrigin(0, 0.5);
		this.scrollContainer.add(exampleSongSolution);
		currentY += 70;

		// Sezione Aiuti
		let aiutiTitle = this.add.text(
			centerX,
			currentY,
			'AIUTI',
			setup.styles.titleStyle
		).setOrigin(0.5);
		this.scrollContainer.add(aiutiTitle);
		currentY += 80;

		// Icona power per la sezione aiuti
		let powerIconSection = this.add.image(
			centerX - 105,
			currentY - 75,
			'power-icon'
		).setScale(0.2);
		this.scrollContainer.add(powerIconSection);

		let aiutiText = this.add.text(
			centerX,
			currentY,
			'Usa i crediti per ottenere aiuti durante il gioco:',
			{
				fontSize: 32,
				fontFamily: 'Arial',
				fill: '#FFFFFF',
				align: 'center'
			}
		).setOrigin(0.5);
		this.scrollContainer.add(aiutiText);
		currentY += 80;

		// Aiuto 1: Svela
		let svelaText = this.add.text(
			40,
			currentY,
			'SVELA: Rivela la casella corrente - costo 1',
			{
				fontSize: 28,
				fontFamily: 'Arial',
				fill: '#FFFFFF',
				align: 'left'
			}
		).setOrigin(0, 0.5);
		this.scrollContainer.add(svelaText);

		let svelaIcon = this.add.image(585, currentY, 'power-icon').setScale(0.1);
		this.scrollContainer.add(svelaIcon);
		currentY += 50;

		// Aiuto 2: Vocale
		let vowelText = this.add.text(
			40,
			currentY,
			'VOCALE: Rivela una vocale nello schema - costo 2',
			{
				fontSize: 28,
				fontFamily: 'Arial',
				fill: '#FFFFFF',
				align: 'left'
			}
		).setOrigin(0, 0.5);
		this.scrollContainer.add(vowelText);

		let vowelIcon = this.add.image(690, currentY, 'power-icon').setScale(0.1);
		this.scrollContainer.add(vowelIcon);
		currentY += 50;

		// Aiuto 3: Consonante
		let consonantText = this.add.text(
			40,
			currentY,
			'CONSONANTE: Rivela una consonante - costo 4',
			{
				fontSize: 28,
				fontFamily: 'Arial',
				fill: '#FFFFFF',
				align: 'left'
			}
		).setOrigin(0, 0.5);
		this.scrollContainer.add(consonantText);

		let consonantIcon = this.add.image(665, currentY, 'power-icon').setScale(0.1);
		this.scrollContainer.add(consonantIcon);
		currentY += 50;

		// Aiuto 4: Parola
		let wordText = this.add.text(
			40,
			currentY,
			'PAROLA: Rivela una parola intera - costo 6',
			{
				fontSize: 28,
				fontFamily: 'Arial',
				fill: '#FFFFFF',
				align: 'left'
			}
		).setOrigin(0, 0.5);
		this.scrollContainer.add(wordText);

		let wordIcon = this.add.image(590, currentY, 'power-icon').setScale(0.1);
		this.scrollContainer.add(wordIcon);
		currentY += 80;

		// Sezione Punti
		let puntiTitle = this.add.text(
			centerX,
			currentY,
			'PUNTI',
			setup.styles.titleStyle
		).setOrigin(0.5);
		this.scrollContainer.add(puntiTitle);
		currentY += 80;

		// Icona score per la sezione punti
		let scoreIconSection = this.add.image(
			centerX - 125,
			currentY - 75,
			'score-icon'
		).setScale(0.2);
		this.scrollContainer.add(scoreIconSection);

		// Testo introduttivo
		let puntiIntro = this.add.text(
			40,
			currentY,
			'Guadagni punti indovinando le lettere.',
			{
				fontSize: 28,
				fontFamily: 'Arial',
				fill: '#FFFFFF',
				align: 'center'
			}
		).setOrigin(0, 0.5);
		this.scrollContainer.add(puntiIntro);
		currentY += 60;

		// Vocali comuni
		let vocaliComuniText = this.add.text(
			40,
			currentY,
			'Vocali comuni (A, E, I, O): 1 punto',
			{
				fontSize: 28,
				fontFamily: 'Arial',
				fill: '#FFFFFF',
				align: 'left'
			}
		).setOrigin(0, 0.5);
		this.scrollContainer.add(vocaliComuniText);

		let vocaliComuniIcon = this.add.image(480, currentY, 'score-icon').setScale(0.1);
		this.scrollContainer.add(vocaliComuniIcon);
		currentY += 50;

		// Consonanti comuni
		let consonantiComuniText = this.add.text(
			40,
			currentY,
			'Consonanti comuni (C, R, S, T): 1-3 punti',
			{
				fontSize: 28,
				fontFamily: 'Arial',
				fill: '#FFFFFF',
				align: 'left'
			}
		).setOrigin(0, 0.5);
		this.scrollContainer.add(consonantiComuniText);

		let consonantiComuniIcon = this.add.image(570, currentY, 'score-icon').setScale(0.1);
		this.scrollContainer.add(consonantiComuniIcon);
		currentY += 50;

		// Lettere rare
		let lettereRareText = this.add.text(
			40,
			currentY,
			'Lettere rare (Q, H, Z): 8-10 punti',
			{
				fontSize: 28,
				fontFamily: 'Arial',
				fill: '#FFFFFF',
				align: 'left'
			}
		).setOrigin(0, 0.5);
		this.scrollContainer.add(lettereRareText);

		let lettereRareIcon = this.add.image(460, currentY, 'score-icon').setScale(0.1);
		this.scrollContainer.add(lettereRareIcon);
		currentY += 50;

		// Lettere molto rare
		let lettereMoltoRareText = this.add.text(
			40,
			currentY,
			'Lettere molto rare (J, K, W, X, Y): 12 punti',
			{
				fontSize: 28,
				fontFamily: 'Arial',
				fill: '#FFFFFF',
				align: 'left'
			}
		).setOrigin(0, 0.5);
		this.scrollContainer.add(lettereMoltoRareText);

		let lettereMoltoRareIcon = this.add.image(580, currentY, 'score-icon').setScale(0.1);
		this.scrollContainer.add(lettereMoltoRareIcon);
		currentY += 80;

		let creditiText = this.add.text(
			40,
			currentY,
			'I punti ti permettono di usare gli aiuti. Li guadagni\nanche risparmiando tempo, vincendo round\ne completando sfide.',
			{
				fontSize: 28,
				fontFamily: 'Arial',
				fill: '#FFFFFF',
				align: 'justify'
			}
		).setOrigin(0, 0.5);
		this.scrollContainer.add(creditiText);
		currentY += 100;

		// Calcola l'altezza totale del contenuto e il max scroll
		let contentHeight = currentY;
		this.maxScrollY = Math.max(0, contentHeight - scrollAreaHeight);

		// Area scrollabile interattiva
		let scrollArea = this.add.rectangle(
			centerX,
			scrollAreaTop + scrollAreaHeight / 2,
			width,
			scrollAreaHeight,
			0x000000,
			0
		).setInteractive({ useHandCursor: false });

		// Variabili per il drag
		let isDragging = false;
		let dragStartY = 0;
		let scrollStartY = 0;
		const scene = this;

		scrollArea.on('pointerdown', function(pointer) {
			isDragging = true;
			dragStartY = pointer.y;
			scrollStartY = scene.scrollY;
		});

		this.input.on('pointermove', function(pointer) {
			if (isDragging && pointer.isDown) {
				let deltaY = dragStartY - pointer.y;
				scene.scrollY = Phaser.Math.Clamp(scrollStartY + deltaY, 0, scene.maxScrollY);
				scene.scrollContainer.y = scrollAreaTop - scene.scrollY;
			}
		});

		this.input.on('pointerup', function() {
			isDragging = false;
		});

		// Scroll con mouse wheel
		this.input.on('wheel', function(pointer, gameObjects, deltaX, deltaY) {
			scene.scrollY = Phaser.Math.Clamp(scene.scrollY - deltaY * 2, 0, scene.maxScrollY);
			scene.scrollContainer.y = scrollAreaTop - scene.scrollY;
		});
	}

	/**
	 * Crea l'header della scena con il pulsante indietro e il titolo.
	 *
	 * @param {number} centerX - Posizione X centrale.
	 */
	createHeader(centerX) {
		const headerY = HEADER_HEIGHT / 2;

		// Header con componente riutilizzabile
		new Header(this, 'COME SI GIOCA');

		// Pulsante back (icona)
		const backArrow = this.add.image(40, headerY, 'back-icon');
		backArrow.setOrigin(0, 0.5);
		backArrow.setInteractive({ useHandCursor: true });

		const scene = this;
		backArrow.on('pointerup', function() {
			audio.playSound(scene, 'button-click');
			scene.cameras.main.fade(250);
			scene.time.delayedCall(
				250,
				function() {
					this.scene.stop();
					if (this.scene.isVisible('Game')) {
						this.scene.resume('Game');
					} else {
						this.scene.start('Game');
					}
				},
				[],
				scene
			);
		});
	}

	/**
	 * Metodo mantenuto per compatibilità con codice esistente.
	 * Non ha più effetto dato che il bottone è stato sostituito dal pulsante back nell'header.
	 *
	 * @param {string} label - Etichetta del bottone (ignorata).
	 */
	changeTextButton(label) {
		// No-op: il bottone è stato rimosso in favore del pulsante back nell'header
	}
}
